import { TemplatePage } from './types';

const powerPointPage: TemplatePage = {
  header: {
    color: '#E3F1F2',
    icon: 'images/video-templates/powerpoint.jpg',
    title: 'Powerpoint video templates',
    title_meta: 'Powerpoint video templates',
    description_meta:
      'Choose one of our professionally designed free video templates or start with a blank video.',
    description:
      'Choose one of our professionally designed free video templates or start with a blank video. Make any video as fun or ' +
      'professional as you want with our range of free free background images and videos.'
  },
  footer: {
    category: 'Powerpoint',
    description:
      'With the help of Wave.video’s broad range of editable holiday video templates, you can create attention-grabbing videos ' +
      'for your social media, blog, website, or email newsletter in minutes. All the templates are free and easy to personalize ' +
      'to suit your brand and topic.'
  },
  content: [
    {
      type: 'templates',
      title: 'powerpoint',
      search: { name: 'powerpoint' }
    },
    {
      type: 'stocks',
      title: 'powerpoint',
      search: { name: 'powerpoint' }
    },
    { type: 'calendar' }
  ]
};

export default powerPointPage;
